import lazySizes from 'lazysizes';

export default lazySizes.init;
